import '../styles/map.scss'

ymaps.ready(function () {

  let myMap;
  myMap = new ymaps.Map("YMapsID", {
    center: [59.8, 31.00],
    zoom:7,
    controls: [
      'zoomControl',
      'searchControl',
      'fullscreenControl',
      'geolocationControl'
    ]
  });

  let mBounds = myMap.getBounds();
  let searchControl = new ymaps.control.SearchControl({ boundedBy: mBounds,
      useMapBounds: true,
      noCentering: true,
      strictBounds: true
      //  noPlacemark: true
   });

  let myCollection = new ymaps.GeoObjectCollection({}, { draggable: false });

  async function render(loc){
    loc.then(data =>
      data.items.forEach(
        val => {
          create_collection(val);
          render_collection();
        }
      )
    );
  }

  function create_collection(val){
    myCollection.add(
      new ymaps.Placemark(
        JSON.parse(val.location),
        {
          balloonContent: balloonContent(val),
          hintContent: hintContent(val),
          // iconContent: '' + val.frequency,
          iconContent: '' + val.broadcast_city
        },
        {
          //preset: 'islands#redIcon',
          preset: ddb_connect(val),
          openEmptyBalloon: false,
          draggable: false,
          hideIconOnBalloonOpen: false,
        }
      )
    );

    myCollection.add(
      new ymaps.GeoObject({
        geometry: {
          type: "Circle",
          coordinates: JSON.parse(val.location),
          radius: val.radius,
        },
        properties: {
          draggable: "false",
          iconContent: '' + val.frequency + 'MHz',
          balloonContent: balloonContent(val),
          hintContent: hintContent(val),
        }
      },
      {
        strokeOpacity: 0.1,
        strokeWidth: 1
      })
    );
  }

  function ddb_connect(val){
    return 'islands#blueIcon';
  }

  function hintContent(val) {
    return '' + val.frequency + 'MHz' + ' ' + val.broadcast_city + ' ' + val.region;
  }

  function balloonContent(val){
    //return '<p>' + '</p><p>' + '' + ' ' + val.frequency + 'MHz</p><p>' + '</p><p>' + Math.round(val.radius/1000) + 'РєРј</p><p>' + val.cities;
    return '<p>'  + ' Freq: ' + val.frequency + 'MHz</p><p>' + '<p>Radius: ' + Math.round(val.radius/1000) + 'km<p></p>' + city_names(val);
  }

  function city_names(val){
    let result = '';
    if ([undefined, null].includes(val['cities'])) {
      if (![undefined, null].includes(val['broadcast_city'])) {
        result = val['broadcast_city'];
      }
    } else {
      val['cities'].forEach((elem) => {
        result += '<span>' + elem.name + '</span><span>( ' + new Intl.NumberFormat("de-DE").format(elem.population) + ' человек), </span>';
      });
    }
    return result;
 }

  let style = [
    {
    "featureType" : "string",
    "stylers" : {
      "hue" : "double",
      "saturation" : "double",
      "lightness" : "double"
      }
    }
  ]

  function render_collection(){
    myMap.geoObjects.add(myCollection);
    myMap.geoObjects.events.add('click', function (e) {
        var geoObject = e.get('target'),
            position = e.get('globalPixels'),
            balloon = geoObject.balloon.open(position);
    //        balloon.events.add('mouseleave', function () {
    //    });
    });
  };

  function cities_url(id) {
    let urlParams = '';
    if (typeof id == 'string' || id instanceof String)
      urlParams = id;
    else
    // let urlParams = new URLSearchParams(window.location.search).get('stream_id');
      urlParams = document.getElementById('station-selector').value;
    switch (urlParams) {
      case ['0', 'rv', 'vanya'].find(name => name === urlParams): {
        return 'https://radiovanya.ru/api/v1/cities';
        break;
      }
      case ['7', 'rdd', 'rddfm'].find(name => name === urlParams): {
        return 'https://rddfm.ru/api/v1/cities';
        break;
      }
      case ['8', 'pfm', 'piterfm'].find(name => name === urlParams): {
        return 'https://radiopiterfm.ru/api/v1/cities';
        break;
      }
      case ['9', 'cl', 'classic','classica'].find(name => name === urlParams): {
        return 'https://player.radioclassica.ru/api/v1/cities';
        break;
      }
      case 'rrd': {
        // return 'https://radiopiterfm.ru/static/rrd.json';
        return 'http://map.m10m.ru/rrd/rrd.json';
        break;
      }

    };
  }

  function get_locations(id){
    return fetch(cities_url(id), {body: JSON.stringify()})
  };

  // function get_locations(){
  //   return fetch('https://radiovanya.ru/api/v1/cities',
  //     {body: JSON.stringify()});
  // };

  async function reload(id){
    let loc = await get_locations(id);
    remove();
    render(loc.json());
  }
  function remove() {
    myCollection.removeAll();
  }

  function default_params(){
    let urlParams;
    if (!(new URLSearchParams(window.location.search).get('stream_id') === null)) {
      urlParams = new URLSearchParams(window.location.search).get('stream_id');
    } else {
      urlParams = window.location.pathname.split('/').filter((str)=> str !== '');
      urlParams = urlParams[urlParams.length - 1];
    }
    // let urlParams = new URLSearchParams(window.location.search).get('stream_id');
    return urlParams;
  }
  reload(default_params());

  let station_slect_element = document.getElementById('station-selector');
  station_slect_element.addEventListener('change', reload, false);

  //setInterval(reload, 0000);
});
